import { render } from "./ModalPerfil.vue?vue&type=template&id=02f97647"
import script from "./ModalPerfil.vue?vue&type=script&lang=js"
export * from "./ModalPerfil.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__